<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column label="分组名称">
          <template slot-scope="scope">

            <div>
              <!-- <div>{{'30天(含)以内'}}</div> -->
              <el-input v-model="scope.row.tabName" :disabled="scope.row.isEdit" placeholder="请输入内容"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分组条件">
          <template slot-scope="scope">
            <div>
              <el-select v-model="scope.row.moreCondition" :disabled="scope.row.isEdit" placeholder="请选择">
                <el-option label="大于" :value="1" />
                <el-option label="大于等于" :value="2" />
              </el-select>
              <el-input-number v-model="scope.row.moreDays" :disabled="scope.row.isEdit" style="width: 100px;"
                controls-position="right" :min="0" label="描述文字"></el-input-number>
              &nbsp;
              <span>天</span> &nbsp;
              <span>且</span> &nbsp;
              <el-select v-model="scope.row.lessCondition" :disabled="scope.row.isEdit" placeholder="请选择">
                <el-option label="小于" :value="1" />
                <el-option label="小于等于" :value="2" />
              </el-select>
              <el-input-number v-model="scope.row.lessDays" :disabled="scope.row.isEdit" style="width: 100px;"
                controls-position="right" :min="0" label="描述文字"></el-input-number>
              &nbsp;
              <span>天</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="210">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isEdit" type="text" v-preventReClick @click="editEvt(scope.row)" class="color-blue">编辑</el-button>
            <el-popconfirm style="margin-left: 5px;" v-if="scope.row.isEdit" title="这是一段内容确定删除吗？" @confirm="deleteEvt(scope.row)">
              <el-button type="text" v-preventReClick slot="reference">删除</el-button>
            </el-popconfirm>
            <el-button v-if="!scope.row.isEdit" type="text" v-preventReClick @click="saveEvt(scope.row,scope.$index)" class="color-blue">保存</el-button>
            <el-button v-if="!scope.row.isEdit" type="text" v-preventReClick @click="cancelEvt(scope.row)" class="color-blue">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <div class="addBox" @click="addEvt">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetStockAgeSettings, SaveStockAgeSetting,RemoveStockAgeSetting } from "@/api";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      query: {},
      tableData: [],
    };
  },
  methods: {
    getList () {
      GetStockAgeSettings(this.query).then(res => {
        if (res.successful) {
          this.tableData = res.returnData.data.map(i => {
            i.isEdit = true
            return i
          })
        }
      })
    },
    saveEvt (row,index) {
      if(!row.tabName){
        this.$my_message(`${index+1+'行、分组名称未填写'}`,'warning') 
        return
      }
      SaveStockAgeSetting(row).then(res => {
        this.getList()
      })
    },
    addEvt () {
      this.tableData.push({
        moreCondition:1,
        moreDays:0
      })
    },
    deleteEvt(row){
      RemoveStockAgeSetting({ids:[row.id]}).then(res=>{
        this.$my_message('删除成功','success')
        this.getList()
      })
    },
    editEvt(row){
      console.log(123);
      this.$set(row,'isEdit',false)
      this.$forceUpdate()
    },
    cancelEvt(row){
      if(row.id){
        this.$set(row,'isEdit',true)
      }else{
        this.tableData.pop()
      }
      this.$forceUpdate()
      this.getList()
    },
    reset(){
      // this.query = {}
      this.getList()
    }
  },
  created () {
    this.getList()
  }
};
</script>

<style lang="scss" scoped>
.addBox {
  width: 96%;
  text-align: center;
  font-size: 20px;
  border: 1px dashed #286ab4;
  border-radius: 10px;
  background-color: #37869978;
  margin: auto;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
</style>